<template>
  <v-container fluid>
    <v-card>

      <v-card-title>
        Trekkers List
      </v-card-title>

      <v-divider />

      <v-data-table
          :headers="headers"
          :items="travellers"
          :loading="loading"
          :items-per-page="rowsPerPage"
          :page.sync="page"
          :server-items-length="total"
          hide-default-footer
          item-key="id"
      >

        <!-- Serial Number -->
        <template v-slot:item.s_no="{ index }">
          {{ (page - 1) * rowsPerPage + index + 1 }}
        </template>

      </v-data-table>

      <!-- Custom Pagination -->
      <v-divider />

      <div class="d-flex align-center justify-space-between pa-3 flex-wrap">

        <!-- Rows Per Page -->
        <div class="d-flex align-center">
          <span class="mr-2">Rows:</span>
          <v-select
              v-model="rowsPerPage"
              :items="rowsPerPageOptions"
              dense
              hide-details
              outlined
              style="max-width: 100px"
              @change="changeRows"
          />
        </div>

        <!-- Page Info -->
        <div>
          Showing
          {{ total === 0 ? 0 : (page - 1) * rowsPerPage + 1 }}
          -
          {{ Math.min(page * rowsPerPage, total) }}
          of {{ total }}
        </div>

        <!-- Navigation -->
        <div>
          <v-btn icon :disabled="page <= 1 || loading" @click="prevPage">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <span class="mx-2">
            Page {{ page }} / {{ totalPages }}
          </span>

          <v-btn icon :disabled="page >= totalPages || loading" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>

      </div>

    </v-card>
  </v-container>
</template>

<script>
import Http from "axios";
import { API_URL, VERSION } from "../../config/config";

export default {
  name: "TrekkerList",

  data() {
    return {
      travellers: [],
      loading: false,

      page: 1,
      rowsPerPage: 50,
      rowsPerPageOptions: [10, 25, 50, 100],

      total: 0,
      totalPages: 1,

      headers: [
        { text: "S.N.", value: "s_no", sortable: false },
        { text: "Submission No", value: "submission_no" },
        { text: "Permit No", value: "permit_no" },
        { text: "Full Name", value: "full_name" },
        { text: "Full Address", value: "full_address" },
        { text: "Contact Number", value: "contact_number" },
      ]
    };
  },

  methods: {

    async loadData() {
      const agencyId = this.$route.params.id;
      if (!agencyId) return;

      this.loading = true;

      try {
        const response = await Http.get(
            `${API_URL}${VERSION}/trekking-agencies/trekker/${agencyId}`,
            {
              params: {
                page: this.page,
                rowsPerPage: this.rowsPerPage
              }
            }
        );

        const { data, meta } = response.data;

        this.travellers = data;
        this.total = meta.total;
        this.totalPages = meta.last_page;
        this.page = meta.current_page;

      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.loading = false;
      }
    },

    changeRows() {
      this.page = 1;
      this.loadData();
    },

    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.loadData();
      }
    },

    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.loadData();
      }
    }

  },

  mounted() {
    this.loadData();
  }
};
</script>